module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Dramatis Personae")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI5")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Brig. H.I. ‘Harry’ Allen")]), _vm._v(", Director, C & D Divisions")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hugh Astor")]), _vm._v(" B1a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Milicent Bagot")]), _vm._v(" B4b")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Susan Barton")]), _vm._v(" B1a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("John Bingham")]), _vm._v(" B5b")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Roland Bird")]), _vm._v(" B3a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("F/Lt Charles Cholmondeley")]), _vm._v(" B1a; member of the Twenty Committee")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maj. Edward Cussen")]), _vm._v(" SLB2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Alan Grogan")]), _vm._v(" B3d")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Brig. Oswald Allen ‘Jasper’ Harker")]), _vm._v(" A/Director (1940-41); Deputy Director General (1941-46)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Christopher Harmer")]), _vm._v(" B1a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tomás Harris")]), _vm._v(" B1g")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C.P. (Cyril) Harvey")]), _vm._v(" B1a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maj. Gen. Sir Vernon Kell")]), _vm._v(" Director General (1909-40)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maj. Maxwell Knight")]), _vm._v(" B5b")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maj. Gilbert Lennox")]), _vm._v(" Room 055, War Office, MI5 liaison")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Capt. Guy Liddell")]), _vm._v(" ADB1, B Division")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("W.E. ‘Billy’ Luke")]), _vm._v(" B1a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("John Marriott")]), _vm._v(" B1a; secretary of the Twenty Committee")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maj. J.C. (John) Masterman")]), _vm._v(" B1a; chairman of the Twenty Committee")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cyril Mills")]), _vm._v(" B1a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Desmond Orr")]), _vm._v(" Room 055, War Office, MI5 liaison")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Brig. Sir David Petrie")]), _vm._v(", Director General (1941-46)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lt Col Thomas Argyll ‘Tar’ Robertson")]), _vm._v(" B1a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Victor, Lord Rothschild")]), _vm._v(" B1c")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dick Goldsmith White")]), _vm._v(" ADB, Assistant Director, B Division")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D.H. Whyte")]), _vm._v(" B2a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D. Ian Wilson")]), _vm._v(" B1a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kenneth Younger")]), _vm._v(" ADE, Assistant Director, E Division")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("William ‘Bill’ Younger")]), _vm._v(" B5b, cousin to Kenneth Younger")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MI6/SIS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Felix Cowgill")]), _vm._v(" Head, Section V")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Maj. Frank Foley")]), _vm._v(" Section V")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Capt. M. Lloyd")]), _vm._v(" Section Vx")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sir Stewart Menzies")]), _vm._v(" ‘C’, Chief of SIS (1939-52)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ian ‘Tim’ Milne")]), _vm._v(" Section Vd")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("H.A.R. ‘Kim’ Philby")]), _vm._v(" Section Vd")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Col Valentine Vivian")]), _vm._v(" VCSS, Vice Chief of SIS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Double Cross Agents")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ARTIST")]), _vm._v(" Johann ‘Johnny’ Jebsen,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BALLOON")]), _vm._v(" Christopher ‘Dicky’ Metcalfe (German: IVAN II)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CARELESS")]), _vm._v(" Clarc Korab")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DREADNOUGHT")]), _vm._v(" Ivo Popov")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("G.W.")]), _vm._v(" Gwilym Williams")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GELATINE")]), _vm._v(" Friedl Gartner (German: YVONNE)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("METEOR")]), _vm._v(" Eugn Šoštarić")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TATE")]), _vm._v(" Wulf Schmidt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TRICYCLE")]), _vm._v("; "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("SKOOT")]), _vm._v(" Dušan ‘Duško’ Miloradoff Popov (German: IVAN I)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VELOCIPEDE")]), _vm._v(" Unidentified")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THE WORM")]), _vm._v(" Stefan Zeis")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b9b3ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Dramatis.vue
// module id = 81
// module chunks = 0